import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";
import RefreshIcon from "../../../assets/Fibo/icons/RefreshIcon";
import BriaTooltip from "../../../components/common/BriaTooltip/BriaTooltip";
import CopyToClipboardButton from "../../../components/common/CopyToClipboardButton/CopyToClipboardButton";
import styles from "../../../layout/LabsLayout/Results/LabResults.module.scss";

type FiboResultHeaderActionsProps = {
	prompt: string;
	copyPromptTooltip: string;
	reusePromptTooltip: string;
	onReusePrompt: (prompt: string) => void;
};

const FiboResultHeaderActions = ({
	prompt,
	copyPromptTooltip,
	reusePromptTooltip,
	onReusePrompt,
}: FiboResultHeaderActionsProps) => {
	return (
		<Box className={styles.resultHeaderActions}>
			<CopyToClipboardButton className={styles.iconButton} textToCopy={prompt} tooltipText={copyPromptTooltip} />
			<BriaTooltip title={reusePromptTooltip}>
				<RefreshIcon className={styles.iconButton} onClick={() => onReusePrompt(prompt)} />
			</BriaTooltip>
		</Box>
	);
};

export default observer(FiboResultHeaderActions);
